import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table,
	Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import Loader from '../../Loader';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import StaffPage from '../../views/StaffPage/';
const GLOBAL = require('../../Globals');
const tabletd = {

	border: '1px solid #063977', borderCollapse: 'collapse', textAlign: 'center', color: '#063977'
};


class EmployeeList extends Component {

	/** set property value **/
	constructor(props) {
		super(props);
		this.state = {
			_subcode: null,
			_subname: null,
			idd: '',
			_message: '',
			value: '',
			alertClass: '',
			posts: [],
			postFilter: [],
			_redirect: false,
			currentPage: 1,
			todosPerPage: 20,
			activePage: 1,
			filteralert: 1,
			empname: '',
			depart: [],
			empstatus: '',
			desig: [],
			desi: '',
			dept: '',
			ename: '',
			ecode: '',
			isload: false,
			modal: false
		}
		this.basestate = this.state;
		this.handleClick = this.handleClick.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onBack = this.onBack.bind(this);
		this.printDocument = this.printDocument.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.onSearchChange = this.onSearchChange.bind(this);
		this.onDeptChange = this.onDeptChange.bind(this);
		this.onEmpstChange = this.onEmpstChange.bind(this);
		this.onDesiChange = this.onDesiChange.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onupdateSubmit = this.onupdateSubmit.bind(this);
		this.onView = this.onView.bind(this);
		this.onShowChange = this.onShowChange.bind(this);
		this.toggle = this.toggle.bind(this);
	}

	onShowChange(e) {

		if (this.state.filteralert == 1) {
			this.state.todosPerPage = e.target.value;
			this.getdata();
		}
		else {
			this.state.todosPerPage = e.target.value;
			this.filterdata();
		}
	}

	toggle() {
		this.setState({
			modal: !this.state.modal
		});
	}

	printDocument() {

		//$("#print-report").show();
		var content = document.getElementById("print-report");
		var pri = document.getElementById("print_frame").contentWindow;
		pri.document.open();
		pri.document.write(content.innerHTML);
		pri.document.close();
		pri.focus();
		pri.print();
	}

	onView(dt) {

		this.state.idd = dt;
		this.setState({
			modal: !this.state.modal
		});
		this.empdata();

	}

	empdata() {

		GetData('employee/getempbyid/' + this.state.idd).then((result) => {
			let res = result;
			if (res) {
				this.setState({
					ename: res[0]['empname'],
					ecode: res[0]['empcode']
				});
			}
		});
	}

	onChange(e) {

		this.setState({ [e.target.name]: e.target.value });
	}

	addtoggle(e) {
		this.setState({
			modal: !this.state.modal
		});
	}

	onupdateSubmit(e) {
		e.preventDefault();
		this.setState({ isload: true });
		if (this.state.idd) {

			PostData('employee/changeempstatus', this.state).then((result) => {
				let responseJson = result;
				if (responseJson.status == '1') {
					this.setState({
						_message: 'Status Changed Successfully!..',
						alertClass: 'alert alert-success',
						modal: !this.state.modal,
						isload: false
					});
					this.getdata();
				}
				else {

					this.setState({
						_message: 'Unable to Change',
						alertClass: 'alert alert-danger'
					});
					this.getdata();
				}
			});

		}

	}

	onSearchChange(e) {

		this.state.empname = e.target.value;
		this.filterdata();
	}

	onDeptChange(e) {

		this.state.dept = e.target.value;
		this.filterdata();
	}

	onEmpstChange(e) {

		this.state.empstatus = e.target.value;
		this.filterdata();
	}

	onDesiChange(e) {

		this.state.desi = e.target.value;
		this.filterdata();
	}

	handlePageChange(pageNumber) {

		this.setState({ activePage: pageNumber });
		this.state.currentPage = Number(pageNumber);
	}

	onBack(e) {

		this.setState({ _redirect: true });
	}

	onClick(e) {

		document.getElementById("empform").reset();
	}

	componentWillMount() {

		this.getdata();
		this.getdepartment();
		this.getdesignation();
	}

	getdata() {
		$("#showLoader").show();
		GetData('employee/getemployee').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					posts: responseJson,
					postFilter: responseJson
				});
				//$('#show option').eq(1).prop('selected', true).trigger('change');
			}
		});
	}

	/** get Department **/
	getdepartment() {

		GetData('department/getdepartment').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					depart: responseJson
				});
			}
		});
	}

	/** get Designation **/
	getdesignation() {

		GetData('designation/getdesignation').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					desig: responseJson
				});
			}
		});
	}

	handleClick(dd) {

		this.state.id = dd;
		console.log('id' + this.state.id);

		if (window.confirm("Do you want to Delete?")) {
			$("#showLoader").show();
			PostData('employee/deleteemployee', this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if (responseJson.status == '1') {
					this.setState({
						_message: 'Employee Removed Successfullly',
						alertClass: 'alert alert-success'
					});
					this.getdata();
				}
				else {

					this.setState({
						_message: 'Error in Remove Employee',
						alertClass: 'alert alert-danger'
					});
				}
			});
		}
	}

	/** pass id to update value **/
	onUpdate(dt) {

		this.state.idd = dt;
		this.setState({ _redirect: true });

	}

	filterdata() {

		this.setState({ filteralert: 2 });
		this.state.postFilter = [];
		var dat = [];

		for (var i = 0; i < this.state.posts.length; i++) {

			if (this.state.empname != '' && this.state.dept == '' && this.state.desi == '' && this.state.empstatus == '') {

				if (this.state.posts[i].empname.toLowerCase().search(this.state.empname.toLowerCase()) != -1) {

					dat.push(this.state.posts[i]);
				}
			}
			else if (this.state.empname == '' && this.state.desi == '' && this.state.dept != '' && this.state.empstatus == '') {

				if (this.state.posts[i].department == this.state.dept) {

					dat.push(this.state.posts[i]);
				}
			}
			else if (this.state.empname == '' && this.state.dept == '' && this.state.desi != '' && this.state.empstatus == '') {

				if (this.state.posts[i].designation == this.state.desi) {

					dat.push(this.state.posts[i]);
				}
			}
			else if (this.state.empname != '' && this.state.dept != '' && this.state.desi == '' && this.state.empstatus == '') {

				if (this.state.posts[i].empname.toLowerCase().search(this.state.empname.toLowerCase()) != -1 && this.state.posts[i].department == this.state.dept) {

					dat.push(this.state.posts[i]);
				}
			}
			else if (this.state.empname != '' && this.state.dept == '' && this.state.desi != '' && this.state.empstatus == '') {

				if (this.state.posts[i].empname.toLowerCase().search(this.state.empname.toLowerCase()) != -1 && this.state.posts[i].designation == this.state.desi) {

					dat.push(this.state.posts[i]);
				}
			}
			else if (this.state.empname != '' && this.state.dept != '' && this.state.desi != '' && this.state.empstatus == '') {

				if (this.state.posts[i].empname.toLowerCase().search(this.state.empname.toLowerCase()) != -1 && this.state.posts[i].department == this.state.dept && this.state.posts[i].designation == this.state.desi) {

					dat.push(this.state.posts[i]);
				}
			}
			else if (this.state.empname == '' && this.state.dept == '' && this.state.desi == '' && this.state.empstatus != '') {

				if (this.state.posts[i].employeestatus == this.state.empstatus) {

					dat.push(this.state.posts[i]);
				}
			}
		}
		this.setState({ postFilter: dat });
	}

	render() {

		/** Redirect to update page **/
		if (this.state._redirect) {

			return (<Redirect to={'/employee/editemployee/' + this.state.idd} />);

		}

		$("#print-report").hide();

		/** set showcount select box **/
		this.shows = [

			{ value: '20', name: '20' },
			{ value: '10', name: '10' },
			{ value: '50', name: '50' },
			{ value: '100', name: '100' }
		];

		this.statuslist = [

			{ value: '', name: '-Select-' },
			{ value: 'active', name: 'Active' },
			{ value: 'resign', name: 'Resigned' },
			{ value: 'left', name: 'Left' },
			{ value: 'terminate', name: 'Terminate' }
		];

		var dept = this.state.depart;
		var des = this.state.desig;

		// Logic for displaying current todos
		const indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
		const indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
		const currentTodos = this.state.postFilter.slice(indexOfFirstTodo, indexOfLastTodo);

		const renderTodos = currentTodos.map((item, i) => {
			return <tr key={item} style={{ backgroundColor: (item.employeestatus == 'active') ? '' : '#e8bdbd' }}>
				<td>{i + 1}</td>
				<td>{item.empcode}</td>
				<td>{item.empname}</td>
				<td>{item.deptname}</td>
				<td>{item.qualification}</td>
				<td>{item.designame}</td>
				<td>{item.mobile}</td>
				<td>{item.employeestatus}</td>
				<td>
					<button name="editemp" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} ><i className="fa fa-edit"></i></button>
					&nbsp;&nbsp;
					<button name="edithw" className="btn btn-success btn-sm" onClick={() => this.onView(item.id)} ><i className="fa fa-check-circle"></i></button>&nbsp;&nbsp;
					<button name="edithw" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>

				</td>
			</tr>;
		});

		return (
			<div>
				<StaffPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Row>
						<Col md="12">
							<Card>
								<CardHeader>
									<strong>Employee List</strong>
									<br />
									<br />
									&nbsp;&nbsp;&nbsp;Employee Name : &nbsp;&nbsp;
								<input type="text" name="empname" onChange={this.onSearchChange} />&nbsp;&nbsp;
								Department : &nbsp;&nbsp;
								<select name="dept" onChange={this.onDeptChange}>
										<option value="">Select Department</option>
										{
											dept.map(function (item) {
												return <option value={item.id}>{item.department}</option>;
											})
										}
									</select>&nbsp;&nbsp;
								Designation : &nbsp;&nbsp;
								<select name="desi" onChange={this.onDesiChange}>
										<option value="">Select Designation</option>
										{
											des.map(function (item) {
												return <option value={item.id}>{item.designation}</option>;
											})
										}
									</select>
									<br />
									<br />
									&nbsp;&nbsp;&nbsp;&nbsp;Status : &nbsp;&nbsp;
								<select name="empstatus" onChange={this.onEmpstChange} required id="empstatus">
										{this.statuslist.map((e, key) => {
											return <option key={key} value={e.value}>{e.name}</option>;
										})}
									</select>&nbsp;&nbsp;&nbsp;&nbsp;
							Total Employees : <span>{this.state.postFilter.length}</span>
									<br />
									<br />
									&nbsp;&nbsp;&nbsp;
							<ReactHTMLTableToExcel
										id="test-table-xls-button"
										className="download-table-xls-button"
										table="table-to-xls_report"
										filename="empolyeelist"
										sheet="tablexls"
										Button size="xs"
										buttonText="Export" />
									<Button size="sm" className="btn-right" color="warning" onClick={this.printDocument}><i className="fa fa-print"></i> Print</Button>
								</CardHeader>
								<CardBody>
									<Row>
										<Col md="12">
											<Table responsive bordered>
												<thead>
													<tr>
														<th>S.No</th>
														<th>Emp Code</th>
														<th>Employee Name</th>
														<th>Department</th>
														<th>Qualification</th>
														<th>Designation</th>
														<th>Mobile</th>
														<th>Status</th>
														<th width="100">Manage</th>
													</tr>
												</thead>
												<tbody>
													{renderTodos}
												</tbody>
											</Table>
										</Col>
										<Col md="4">
											<Pagination
												activePage={this.state.activePage}
												itemsCountPerPage={this.state.todosPerPage}
												pageRangeDisplayed={3}
												totalItemsCount={this.state.postFilter.length}
												onChange={this.handlePageChange}
											/>
										</Col>
										<Col md="2">
											show &nbsp;
								<select name="show" id="show" onChange={this.onShowChange} >
												{this.shows.map((e, key) => {
													return <option key={key} value={e.value}>{e.name}</option>;
												})}
											</select>&nbsp;
									   entries
					</Col>
										<Modal isOpen={this.state.modal} toggle={this.addtoggle} className={'modal-lg ' + this.props.className}>
											<form action="" method="post" role="form" id="chform" encType="multipart/form-data" onSubmit={this.onupdateSubmit}>
												<ModalHeader toggle={this.toggle}>Employee  Name : {this.state.ename} &nbsp;Employee Code : {this.state.ecode}</ModalHeader>
												<ModalBody>
													<Row>
														<Col md="3">
															<FormGroup>
																<Label>Status</Label>
															</FormGroup>
														</Col>
														<Col md="9">
															<FormGroup>
																<select name="estatus" className="form-control" onChange={this.onChange} required id="estatus">
																	{this.statuslist.map((e, key) => {
																		return <option key={key} value={e.value}>{e.name}</option>;
																	})}
																</select>
															</FormGroup>
														</Col>
														<Col md="3">
															<FormGroup>
																<Label>Date</Label>
															</FormGroup>
														</Col>
														<Col md="9">
															<FormGroup>
																<Input type="date" name="estdate" className="form-control" onChange={this.onChange} required />
															</FormGroup>
														</Col>
														<Col md="3">
															<FormGroup>
																<Label>Reason</Label>
															</FormGroup>
														</Col>
														<Col md="9">
															<FormGroup>
																<Input type="textarea" name="reason" className="form-control" onChange={this.onChange} />
															</FormGroup>
														</Col>
													</Row>
												</ModalBody>
												<ModalFooter>
													<Button type="submit" color="success" >{this.state.isload ? <Loader /> : 'Update'}</Button>{' '}
													<Button color="secondary" onClick={this.toggle}>Cancel</Button>
												</ModalFooter>
											</form>
										</Modal>
									</Row>
								</CardBody>
							</Card>
							<Card>
								<CardBody id="print-report">
									<Row>
										<table id="" align="center">
											<tbody>
												<tr>
													<td rowSpan="4" style={{ marginLeft: 'auto', marginRight: 'auto', textAlign: 'center' }}><img src={GLOBAL.BASE_URL + 'public/sclogo/logo.jpg'} width="70" /></td>
												</tr>
												<tr>
													<td style={{ marginLeft: 'auto', marginRight: 'auto', textAlign: 'center', fontSize: '18px', fontWeight: 'bold', color: '#8a260e' }} >{GLOBAL.Sclful_NAME}</td>
												</tr>
												<tr>
													<td style={{ marginLeft: 'auto', marginRight: 'auto', textAlign: 'center', fontSize: '14px', fontWeight: 'bold', color: '#1d4f71' }}>{GLOBAL.Scl_Addr}</td>
												</tr>
												<tr>
													<td style={{ marginLeft: 'auto', marginRight: 'auto', textAlign: 'center', fontSize: '14px', fontWeight: 'bold', color: '#1d4f71' }}>{GLOBAL.Scl_Dist}</td>
												</tr>
											</tbody>
										</table>
										<br />
										<Col md="12">
											<Table responsive style={{ border: '1px solid black', borderCollapse: 'collapse' }} width="100%" align="center" id="table-to-xls_report">
												<thead>
													<tr>
														<th style={tabletd}>S.No</th>
														<th style={tabletd}>Emp Code</th>
														<th style={tabletd}>Employee Name</th>
														<th style={tabletd}>Department</th>
														<th style={tabletd}>Qualification</th>
														<th style={tabletd}>Designation</th>
														<th style={tabletd}>Mobile</th>
														<th style={tabletd}>Status</th>
													</tr>
												</thead>
												<tbody>
													{this.state.postFilter.map((item, index) =>

														<tr key={item}>
															<td style={tabletd}>{index + 1}</td>
															<td style={tabletd}>{item.empcode}</td>
															<td style={tabletd}>{item.empname}</td>
															<td style={tabletd}>{item.deptname}</td>
															<td style={tabletd}>{item.qualification}</td>
															<td style={tabletd}>{item.designame}</td>
															<td style={tabletd}>{item.mobile}</td>
															<td style={tabletd}>{item.employeestatus}</td>
														</tr>
													)}
												</tbody>
											</Table>
										</Col>
									</Row>
								</CardBody>
								<iframe name="print_frame" id="print_frame" width="0" height="0" frameborder="0" src="about:blank"></iframe>
							</Card>
						</Col>
					</Row>
				</div>
			</div>
		)
	}
}

export default EmployeeList;


// WEBPACK FOOTER //
// ./src/employee/Employee/EmployeeList.js